import React from 'react';
import { BsCheckCircleFill } from 'react-icons/bs';
import styles from './ImportMethodSelector.module.scss';

/**
 * Grid of selectable cards for choosing how to bring employees in
 * (invite one-by-one, import a file, etc). Each method is
 * `{ key, icon, iconBg, title, desc, enabled }`.
 */
export const ImportMethodSelector = ({
  methods,
  selectedMethod,
  onSelect,
  accentColor = 'var(--blue-600)',
  dataTour,
}) => (
  <div
    className={styles.importMethods}
    data-tour={dataTour}
    style={{
      '--import-method-accent': accentColor,
      '--import-method-columns': methods.length,
    }}
  >
    {methods.map((method) => {
      const isSelected = selectedMethod === method.key;
      return (
        <div
          key={method.key}
          data-key={method.key}
          className={`${styles.importMethodCard} ${
            isSelected ? styles.importMethodCardSelected : ''
          } ${!method.enabled ? styles.importMethodCardDisabled : ''}`}
          onClick={() => method.enabled && onSelect(method.key)}
          role={method.enabled ? 'button' : undefined}
          tabIndex={method.enabled ? 0 : undefined}
          onKeyDown={(e) =>
            method.enabled &&
            (e.key === 'Enter' || e.key === ' ') &&
            onSelect(method.key)
          }
        >
          {isSelected && (
            <BsCheckCircleFill size={20} className={styles.importMethodCheck} />
          )}
          <div
            className={styles.importMethodIconWrap}
            style={{ backgroundColor: method.iconBg }}
          >
            {method.icon}
          </div>
          <h3 className={styles.importMethodTitle}>{method.title}</h3>
          <p className={styles.importMethodDesc}>{method.desc}</p>
        </div>
      );
    })}
  </div>
);
